import { useState, useEffect } from 'react';
import patientStatusConfigService from '../services/patientStatusConfigService';
import { useTenant } from '../context/TenantContext';

/**
 * Fetches patient status configs and returns a map of key → title.
 * Falls back to the raw key if no config is found for it.
 */
export const usePatientStatusConfigs = (): {
  statusLabel: (key: string) => string;
  statusTitles: Record<string, string>;
  loading: boolean;
} => {
  const { currentTenant } = useTenant();
  const [statusTitles, setStatusTitles] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentTenant) return;
    patientStatusConfigService.getAll(currentTenant.id)
      .then((configs) => {
        const map: Record<string, string> = {};
        configs.forEach((c) => { map[c.key] = c.title; });
        setStatusTitles(map);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [currentTenant]);

  const statusLabel = (key: string): string => statusTitles[key] ?? key;

  return { statusLabel, statusTitles, loading };
};
